import { jsx } from '@amazon/vinyl-tsx'
import { data } from '@amazon/vinyl-observable'
import { ShareModal, type ShareModalModel } from '@/detailpage/ShareModal'
import { openModal } from '@/components/modalLayer'

/**
 * Opens the singleton ShareModal via the app-level modal layer.
 *
 * The previous implementation parked a per-callsite ShareModal
 * inside an in-row portal that reparented to `<body>`. Inside the
 * virtualized track list that was racy: when rows recycled the
 * orphaned portal could still sit in body and later Share clicks
 * hit the stale subscription. Centralizing the modal through
 * `openModal` keeps a single instance alive and tied to the
 * caller's open-time intent.
 */
export function openShareModal(model: ShareModalModel): void {
    openModal({
        render: (close) => {
            const visible = data(true)
            const dataRef = data(model)
            return (
                <ShareModal
                    visible={visible}
                    data={dataRef}
                    onClose={() => {
                        visible.value = false
                        // Defer the actual unmount so the modal's
                        // visibility-toggle callbacks settle before
                        // we yank the node — otherwise the close
                        // animation (such as it is) never gets to
                        // play out.
                        queueMicrotask(close)
                    }}
                />
            )
        },
    })
}
